import { useQuery } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import { FavoriteCompaniesResponse } from 'src/types/favorite';
import axiosInstance from 'src/utils/axios';

export async function fetchFavoriteCompanies(): Promise<FavoriteCompaniesResponse> {
  const response = await axiosInstance.get<FavoriteCompaniesResponse>(api.getFavoriteCompanies);
  return response.data;
}

const useGetFavoriteCompaniesQuery = (enabled = true) =>
  useQuery<FavoriteCompaniesResponse>({
    queryKey: queryKeys.favorite.companies(),
    queryFn: fetchFavoriteCompanies,
    enabled,
  });

export default useGetFavoriteCompaniesQuery;
